<template>
  <div>
    <div
      id="reportModal"
      class="modal fade"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <ValidationObserver
          ref="letter"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <div class="letter-modal">
            <div class="note-wrap">
              <div class="letter-title">報到通知</div>

              <div class="note-title">可動態套入信件內容，請參考以下參數</div>
              <div class="note-table">
                <table v-if="mailParameters">
                  <tr
                    v-for="parameter in mailParameters"
                    :key="parameter.MailParameterCode"
                  >
                    <th>{{ parameter.MailParameterName }}</th>
                    <td>
                      <span>{{</span>{{ parameter.MailParameterCode
                      }}<span>}}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <form @reset.prevent="reset">
              <div class="modal-content border-0">
                <perfect-scrollbar class="modal-body">
                  <div class="form-group">
                    <label for="">姓名：</label>
                    <span>{{ mail.Name }}</span>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="單位"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>
                        <span>任用單位：</span>
                      </label>
                      <treeselect
                        :options="departmentOptions"
                        :searchable="true"
                        :show-count="true"
                        :default-expand-level="1"
                        placeholder="請選擇"
                        valueFormat="object"
                        v-model="mail.Group"
                      >
                        <label
                          slot="option-label"
                          slot-scope="{
                            node,
                            shouldShowCount,
                            count,
                            labelClassName,
                            countClassName,
                          }"
                          :class="labelClassName"
                          for=""
                        >
                          {{ node.label }}
                          <span v-if="shouldShowCount" :class="countClassName">
                            ({{ count }})
                          </span>
                        </label>
                      </treeselect>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="工作職稱"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>
                        <span>職務名稱：</span>
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="mail.Job"
                      >
                        <el-option
                          v-for="item in positionOptions"
                          :key="item.PositionCode"
                          :label="item.PositionName"
                          :value="item.PositionName"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <label for="">
                        <span style="color: red">*</span>
                        <span>報到日期：</span>
                      </label>
                      <date-picker
                        class="w-100"
                        format="YYYY-MM-DD"
                        valueType="format"
                        placeholder="YYYY-MM-DD"
                        :disabled-date="$common.disabledDateBeforeToday"
                        v-model="mail.ReportedDate"
                      >
                      </date-picker>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <label for="reportTime">
                        <span style="color: red">*</span>
                        <span>報到時間：</span>
                      </label>
                      <date-picker
                        class="w-100"
                        format="HH:mm"
                        value-type="format"
                        type="time"
                        :default-value="new Date().setHours(8, 0, 0, 0)"
                        :minute-step="5"
                        placeholder="HH:mm"
                        v-model="mail.ReportedTime"
                      ></date-picker>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <label for="">
                        <span style="color: red">*</span>
                        <span>報到地點：</span>
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="mail.Place"
                      >
                        <el-option
                          v-for="place in reportPlaceOptions"
                          :key="place.Guid"
                          :label="place.Name"
                          :value="place.Name"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="聯絡資訊"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>
                        <span>聯絡資訊：</span>
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="mail.ContactInfo"
                      >
                        <el-option
                          v-for="person in contactOptions"
                          :key="person.Guid"
                          :label="person.Name"
                          :value="person.Name"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for="">附件：</label>
                    <el-upload
                      class="upload-demo"
                      action
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="uploadFile"
                    >
                      <el-button size="small" type="primary">
                        點擊上傳
                      </el-button>
                    </el-upload>
                    <template v-if="uploadFileList">
                      <div v-for="file in uploadFileList" :key="file.FileGuid">
                        <p
                          style="margin-top: 20px; cursor: pointer"
                          @click="
                            $common.downloadFile({
                              fileGuid: file.FileGuid,
                              fileType: file.FileContentType,
                            })
                          "
                        >
                          <eva-icon fill="#000" name="attach-outline" />
                          <span
                            style="margin-left: 15px; vertical-align: text-top"
                          >
                            {{ file.FileName }}
                          </span>
                          <span
                            style="
                              display: inline-block;
                              position: absolute;
                              right: 25px;
                            "
                            @click.stop="
                              removeFile({
                                fileGuid: file.FileGuid,
                                fileGroupGuid: file.FileGroupGuid,
                              })
                            "
                          >
                            <eva-icon fill="#000" name="trash-2-outline" />
                          </span>
                        </p>
                      </div>
                    </template>
                  </div>

                  <div class="form-group">
                    <label for=""> 信件範本： </label>
                    <select
                      class="form-control w-100"
                      @change="getMailTemplateDetail"
                      v-model="selectedTemplateGuid"
                    >
                      <option :value="null" disabled>請選擇</option>
                      <option
                        v-for="template in mailTemplates"
                        :key="template.MailTemplateGuid"
                        :value="template.MailTemplateGuid"
                      >
                        {{ template.MailTemplateName }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="信件主旨"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>信件主旨： </label>
                      <input
                        placeholder="請輸入信件主旨或選擇範本"
                        class="form-control w-100"
                        v-model="mail.MailSubject"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="信件內容"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>信件內容： </label>
                      <VueEditor
                        style="background: rgb(255, 255, 255)"
                        v-model="mail.MailTemplateBody"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                </perfect-scrollbar>

                <div class="modal-footer">
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="closeReportMailModal"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(showPreview)"
                  >
                    預覽
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    :disabled="clickDisabled"
                    @click="handleSubmit(sendLetter)"
                  >
                    寄出
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <!-- 預覽 Modal -->
    <div
      class="modal fade"
      id="previewMail"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">預覽信件</h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              data-dismiss="modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <perfect-scrollbar class="modal-body">
            <div class="preview-body row">
              <div class="col-1">
                <Logo />
              </div>
              <div class="col-10" style="padding-left: 5px">
                收件者：<span
                  v-for="(recipient, index) in previewMail.Recipients"
                  :key="recipient[index]"
                >
                  <el-tag size="small">{{
                    recipient.Name + "(" + recipient.Address + ")"
                  }}</el-tag
                  >;
                </span>
                <br />
                副本：<span
                  v-for="(cc, index) in previewMail.CCs"
                  :key="cc[index]"
                >
                  <el-tag size="small" type="info">{{
                    cc.Name + "(" + cc.Address + ")"
                  }}</el-tag
                  >;
                </span>
                <br />
                <span>主旨：{{ previewMail.Subject }}</span>
              </div>
            </div>

            <div class="mt-1" v-html="previewMail.Body"></div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import Logo from "@/components/company/Logo.vue";

export default {
  props: ["personData"],

  name: "ReportMail",
  components: {
    Logo,
  },
  data() {
    return {
      // 範本
      mailParameters: {},
      mailTemplates: [],

      // 所選擇範本的 guid
      selectedTemplateGuid: null,

      // 部門列表
      departmentOptions: [],
      // 職務列表
      positionOptions: [],
      // 報到地點
      reportPlaceOptions: [],

      // 信件資訊
      mail: {},
      // 預覽內容
      previewMail: {},
      // 寄出按鈕
      clickDisabled: false,

      // 聯絡資訊
      contactOptions: [],

      // 附件
      fileGroupGuid: "",
      resetFileStatus: true, // 第一次必為 true
      uploadFileList: [], // 上傳附件列表
    };
  },

  computed: {
    ...mapGetters(["showReportMail"]),
  },

  watch: {
    showReportMail: function (e) {
      if (e) {
        this.selectedTemplateGuid = null;
        this.mail = {
          Name: this.personData.Name,
          Group: this.personData.AppointmentDepartmentGuid
            ? {
                id: this.personData.AppointmentDepartmentGuid,
                label: this.personData.AppointmentDepartment,
              }
            : null,
          ReportedDate: null,
          ReportedTime: null,
          Job: this.personData.Position,
          Email: this.personData.Email,
          MatchId: this.personData.MatchId,
        };
        this.fileGroupGuid = "";
        this.resetFileStatus = true;
        this.uploadFileList = [];
        this.$refs.letter.reset();
        this.clickDisabled = false;
        $("#reportModal").modal("show");
      } else {
        this.mail = {};
        $("#reportModal").modal("hide");
      }
    },
  },

  methods: {
    // 上傳 附件
    uploadFile(file) {
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", this.fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          this.fileGroupGuid = response.data;
          this.resetFileStatus = false;
          this.getFileList(this.fileGroupGuid);
        }
      });
    },

    // 取得 附件
    getFileList(fileGroupGuid) {
      this.updateLoading(true);
      const params = {
        resetFileStatus: this.resetFileStatus,
      };
      this.$api.file.getFileDetails(params, fileGroupGuid).then((response) => {
        if (response.status === 200) {
          this.uploadFileList = response.data.filter((item) => !item.IsDelete);
        }
        this.updateLoading(false);
      });
    },

    // 刪除 附件
    removeFile({ fileGuid, fileGroupGuid }) {
      this.updateLoading(true);
      this.$api.file.removeFile(fileGuid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2500,
          });
          this.uploadFileList = [];
          this.resetFileStatus = false;
          this.getFileList(fileGroupGuid);
        }
        this.updateLoading(false);
      });
    },

    // 報到通知
    sendLetter() {
      this.clickDisabled = true;
      this.updateLoading(true);

      this.$api.notice
        .noticeOfReport({
          ...this.mail,
          Time: this.mail.ReportedDate + "T" + this.mail.ReportedTime + "Z",
          Group: this.mail.Group.label,
          MailSenderGuid: this.$cookies.get("userId"),
          FileGroupId: this.fileGroupGuid ? this.fileGroupGuid : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.clickDisabled = false;
            this.updateLoading(false);
            this.$notify({
              title: "成功",
              message: "報到通知信已寄出",
              type: "success",
              duration: 2500,
            });
            this.$emit("updatePerson", this.personData.MatchId, "報到通知");
          }
        })
        .catch(() => {
          this.clickDisabled = false;
          this.updateLoading(false);
        });
    },

    // 依guid 取得信件範本內容
    getMailTemplateDetail() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .getMailTemplateDetail(this.selectedTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$set(
              this.mail,
              "MailSubject",
              response.data.MailTemplateSubject
            );
            this.$set(
              this.mail,
              "MailTemplateBody",
              response.data.MailTemplateBody
            );
          }
          this.updateLoading(false);
        });
    },

    // 預覽
    showPreview() {
      this.updateLoading(true);
      this.$api.sendmail
        .previewReportMail({
          ...this.mail,
          Group: this.mail.Group.label,
          Time: this.mail.ReportedDate + "T" + this.mail.ReportedTime + "Z",
        })
        .then((response) => {
          if (response.status === 200) {
            this.previewMail = response.data;
            $("#previewMail").modal("show");
          }
          this.updateLoading(false);
        });
    },

    // 點擊取消
    closeReportMailModal() {
      this.$store.commit("OpenReportMailModal", false);
    },

    async getData() {
      await this.$http
        .all([
          this.$api.department.getDepartment(),
          this.get_position(null),
          this.$api.mailTemplate.getMailParameter(
            "954354ED-E2B4-4A37-932A-AB913648DC7E"
          ),
          this.$api.mailTemplate.getMailTemplatePaging(
            { isPaging: false },
            "OnBoard"
          ),
          this.$api.interviewPlace.getInterviewPlacePaging({ isPaging: false }),
          this.$api.contactInfo.getContactInfo(),
        ])
        .then(
          this.$http.spread(
            (department, position, parameter, template, place, contact) => {
              // 取得 部門選項
              this.departmentOptions = department.data;
              // 取得 職務選項
              this.positionOptions = position;
              // 取得 信件參數
              this.mailParameters = parameter.data;
              // 取得 信件範本
              this.mailTemplates = template.data.Datas;
              // 取得 報到地點
              this.reportPlaceOptions = place.data.Data;
              // 取得 聯絡資訊
              this.contactOptions = contact.data;
            }
          )
        );
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
#previewMail {
  .modal-header {
    margin: 10px 10px 0 10px;
    .modal-title {
      display: inline-block;
    }
  }

  .modal-body {
    text-align: left;
    .preview-body {
      margin-top: 10px;
      span {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
